import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { Auth } from '../utils/api';

const AuthCtx = createContext({ me: null, loading: true, perms: [], refresh: async () => { } });

export function AuthProvider({ children }) {
    const [me, setMe] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                // backend /api/me trả { id, username, display_name, permissions: [] }
                const data = await Auth.me();
                if (!cancelled) setMe(data || null);
            } catch {
                if (!cancelled) setMe(null);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => (cancelled = true);
    }, []);

    const value = useMemo(() => ({
        me, loading, perms: me?.permissions || [],
        refresh: async () => {
            setLoading(true);
            try { setMe(await Auth.me()); } catch { setMe(null); }
            finally { setLoading(false); }
        }
    }), [me, loading]);

    return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
